import React, { useMemo, useState } from 'react'
import CommonCard from '../../../global/card'
import CommonSkeletonLoader from '../../../global/loading'
import { useGenericQuery } from '../../../../queries/use-generic-query';
import SOURCES from '../../../../utils/constants';
import { QUERY_KEYS } from '../../../../lib/query-constants';
import useDebounce from '../../../../utils/customHooks';
import { useLocation } from 'react-router-dom';
import EnhancedAutorespondersList from './enhancedAutorespondersList';
import EnhancedAddAutoresponders from './enhancedAddAutoresponders';
import { useQueryClient } from '@tanstack/react-query';

const EnhancedAutoresponders = () => {
    const { DEFAULT_RECORDS_LISTING } = SOURCES;

    const [automationsViewType, setAutomationsViewType] = useState(() => {
        return localStorage.getItem("automationsViewType") || "GRID";
    });
    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });

    const [editAutomation, setEditAutomation] = useState({
        show: false,
        id: null
    })

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pageFromQuery = parseInt(searchParams.get("page") || 1, 10);
    const limitFromQuery = parseInt(
        searchParams.get("limit") || DEFAULT_RECORDS_LISTING,
        10
    );
    const offsetFromQuery = parseInt(searchParams.get("offset") || "0", 10);

    const [pagination, setPagination] = useState({
        offset: offsetFromQuery,
        limit: limitFromQuery,
        page: pageFromQuery,
    });

    const keyParams = {
        offset: pagination.offset,
        limit: pagination.limit,
        sortBy: sort.sortType,
        sortOrder: sort.sortOrder
    }

    const queryClient = useQueryClient()
    // Fetching data
    const queryKey = QUERY_KEYS.autoresponders.lists(keyParams);
    const { data: automationsData, isLoading, isFetching } = useGenericQuery({
        endpoint: "autoresponder",
        queryKey,
        queryParams: keyParams,
    });


    const getFinalData = useMemo(() => {
        let results = automationsData || [];
        return results;
    }, [automationsData]);

    return (
        <CommonCard
            isListGridView={{
                show: true,
                viewType: automationsViewType,
                setViewType: setAutomationsViewType,
                viewFor: "automationsViewType"
            }}
            isLoading={{
                show: isLoading,
                loaderCmp: (
                    <CommonSkeletonLoader
                        rows={9}
                        type={automationsViewType === "GRID" ? "card" : "table"}
                        tableLength={7}
                    />
                ),
            }}
            isCreateButton={{
                show: true,
                text: "New Autoresponder",
                onclick: () => setEditAutomation({
                    show: true,
                    id: null
                }),
            }}
            className={(!isLoading && isFetching) ? "opacity-50" : ""}

        >
            <EnhancedAutorespondersList
                automations={getFinalData}
                sort={sort}
                setSort={setSort}
                isLoading={isLoading}
                viewType={automationsViewType}
                setEditAutomation={setEditAutomation}
                keyParams={keyParams}
            />
            {editAutomation.show && (
                <EnhancedAddAutoresponders
                    showForm={editAutomation.show}
                    setShowForm={(val) => setEditAutomation(prev => ({ ...prev, show: val }))}
                    editAutomation={editAutomation}
                    keyParams={keyParams}
                />
            )}
        </CommonCard>
    )
}

export default EnhancedAutoresponders;
